import { render } from "./SurveySettings.vue?vue&type=template&id=6ac93bed"
import script from "./SurveySettings.vue?vue&type=script&lang=js"
export * from "./SurveySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__